import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { HttpEventType, HttpEvent } from "@angular/common/http";
import { ApiClientService } from "@shared/_services/api-client.service";
import { ToastrService } from 'ngx-toastr';
import { FormsModule } from '@angular/forms';
import { PreloaderComponent } from '@app/modules/utils/preloader/preloader.component';

@Component({
  selector: 'app-manage-categories',
  standalone: true,
  imports: [CommonModule, FormsModule, PreloaderComponent],
  providers: [
    ToastrService,
  ],
  templateUrl: './manage-categories.component.html',
  styleUrl: './manage-categories.component.css'
})
export class ManageCategoriesComponent {
  loading: boolean = false;
  @Input() manageCategoryData: any = {};
  @Output() categoryResponseEvent = new EventEmitter<string>();
  public categoryModel: any = {};
  public hasError: boolean = false;
  public errorMsg: string = '';

  constructor(private _apiClientService: ApiClientService, private _toastrService: ToastrService) { }

  ngOnInit() {
    console.log("Manage Categories Data ", this.manageCategoryData);
    this.categoryModel = this.manageCategoryData.data || {};
  }

  onSubmit() {
    if (this.manageCategoryData.action == 'add') {
      this.addCategory(this.categoryModel);
    } else if (this.manageCategoryData.action == 'edit') {
      this.updateCategory(this.categoryModel);
    }
  }

  public async addCategory(region: any) {
    this.loading = true;
    (await this._apiClientService.addApiService('admin/select-option/category/create', region)).subscribe(
      (event: HttpEvent<any>): any => {
        switch (event.type) {
          case HttpEventType.Sent:
            this.loading = true;
            break;
          case HttpEventType.Response:
            this.loading = false;
            let { status, error, message, data } = event.body;
            this._toastrService.success('Success', 'Added Category Successfully');
            //if (status == 200) {
              this.triggerCategoryResponse('completed');
          // } else {
          //   this.hasError = true;
          //   this.errorMsg = 'something went wrong please contact Technical Support';
          // }
        }
      },
      (errorObj: any) => {
        this.loading = false;
        const errorMsg = errorObj?.error?.Message;
        this.hasError = true;
        this.errorMsg = errorMsg || 'something went wrong please contact Technical Support';
      }
    );
  }

  public async updateCategory(region: any) {
    this.loading = true;
    (await this._apiClientService.addApiService(`admin/select-option/category/${region.id}/edit`, region)).subscribe(
      (event: HttpEvent<any>): any => {
        switch (event.type) {
          case HttpEventType.Sent:
            this.loading = true;
            break;
          case HttpEventType.Response:
            this.loading = false;
            this._toastrService.success('Updated Category Successfully', 'Success');
            //let { status, error, message, data } = event.body;
            //if (status == 200) {
            this.triggerCategoryResponse('completed');
          // } else {
          //   this.hasError = true;
          //   this.errorMsg = 'something went wrong please contact Technical Support';
          // }
        }
      },
      (errorObj: any) => {
        this.loading = false;
        const errorMsg = errorObj?.error?.Message;
        this.hasError = true;
        this.errorMsg = errorMsg || 'something went wrong please contact Technical Support';
      }
    );
  }

  public triggerCategoryResponse(action: string) {
    this.categoryResponseEvent.emit(action);
  }
}
